import React, { useState, useEffect, useCallback } from 'react';
import { inventoryAPI } from '../../services/api';
import toast from 'react-hot-toast';

const moveColors = { purchase_in: 'badge-green', sale_out: 'badge-red', return_in: 'badge-blue', return_out: 'badge-orange', transfer_in: 'badge-purple', transfer_out: 'badge-yellow', adjustment_in: 'badge-green', adjustment_out: 'badge-red', damage: 'badge-red', expiry_write_off: 'badge-red', opening_stock: 'badge-gray' };

export default function StockMovements() {
  const [movements, setMovements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [type, setType] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await inventoryAPI.movements({ type, limit: 100 });
      setMovements(res.data.movements);
    } catch { toast.error('Failed to load'); }
    finally { setLoading(false); }
  }, [type]);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div className="page-header">
        <div><h1>Stock Ledger</h1><p className="subtitle">All inventory movements</p></div>
        <select className="form-select" style={{width:'auto', minWidth:180}} value={type} onChange={e => setType(e.target.value)}>
          <option value="">All Types</option>
          <option value="purchase_in">Purchase In</option><option value="sale_out">Sale Out</option>
          <option value="return_in">Return In</option><option value="transfer_in">Transfer In</option>
          <option value="transfer_out">Transfer Out</option><option value="adjustment_in">Adjustment In</option>
          <option value="adjustment_out">Adjustment Out</option>
        </select>
      </div>
      <div className="card">
        <div className="table-container">
          {loading ? <div className="loading-container"><div className="spinner" /></div> : (
            <table>
              <thead><tr><th>Date</th><th>Product</th><th>Batch</th><th>Warehouse</th><th>Type</th><th style={{textAlign:'right'}}>Qty</th><th>By</th></tr></thead>
              <tbody>
                {movements.map(m => (
                  <tr key={m.id}>
                    <td className="text-secondary">{new Date(m.created_at).toLocaleString('en-IN', {dateStyle:'medium', timeStyle:'short'})}</td>
                    <td style={{fontWeight:600}}>{m.product_name}<div className="text-xs text-secondary">{m.sku}</div></td>
                    <td className="td-mono">{m.batch_number || '-'}</td>
                    <td>{m.warehouse_name}</td>
                    <td><span className={`badge ${moveColors[m.movement_type] || 'badge-gray'}`}>{m.movement_type.replace(/_/g,' ')}</span></td>
                    <td className="td-amount font-bold" style={{color: m.movement_type.includes('in') || m.movement_type === 'opening_stock' ? 'var(--success)' : 'var(--danger)'}}>{m.movement_type.includes('out') || m.movement_type === 'damage' ? '-' : '+'}{m.quantity}</td>
                    <td className="text-secondary">{m.created_by_name || '-'}</td>
                  </tr>
                ))}
                {movements.length === 0 && <tr><td colSpan={7} className="text-center text-secondary" style={{padding:40}}>No movements found</td></tr>}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
